import { Route } from "react-router-dom";
import PlanCatalogView from "../views/PlanCatalogView";


// The plan catalog: the plans, their figures and the general prices. Root only -- the page
// itself checks, and so does the hub.
function PlanCatalogRoutes() {
    return (
        [
            <Route key="plan-catalog" path="/plan-catalog" element={<PlanCatalogView />} />
        ]
    );
}

export default PlanCatalogRoutes;
